import Card from './Card.js'
import './Card.scss'
export default Card
